<sw-page class="dvsn-form-builder dvsn-form-builder-submission-detail">
    <template #smart-bar-actions>
        <mt-button
            :disabled="isLoading"
            variant="secondary"
            size="default"
            @click="$router.push({ name: 'dvsn.form.builder.submission.list' })"
        >
            {{ $t('dvsn-form-builder-submission.detail.actions.cancel-button') }}
        </mt-button>
    </template>

    <template #side-content>
        <dvsn-form-builder-side-menu
            active="submission"
            :isLoading="isLoading"
        ></dvsn-form-builder-side-menu>
    </template>

    <template #content>
        <sw-card-view>
            <mt-card
                :isLoading="isLoading"
                :title="$t('dvsn-form-builder-submission.detail.card-base.title')"
                class="card-base"
            >
                <sw-container
                    columns="1fr 2fr"
                    class="element"
                    style="column-gap: 30px;"
                    v-for="element in elements"
                >
                    <div>{{ element.key }}</div>
                    <div v-html="getValue(element)"></div>
                </sw-container>
            </mt-card>
        </sw-card-view>
    </template>
</sw-page>